import { get } from "lodash";
import React, { Fragment, PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";
import { Formik, Form, Field } from "formik";

import * as Yup from "yup";
import * as Schemas from "../forms/validationSchemas.js";

import FormikSemanticDropdown from "../forms/formik/FormikSemanticDropdown.jsx";
import FormikActionsPanel from "../forms/formik/FormikActionsPanel.jsx";

// Designed to be used with the withBasicForm HOC

class MiscellaneousForm extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    onReset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onFormikSubmit: PropTypes.func.isRequired,
    renderMessage: PropTypes.func.isRequired,
    violationErrors: PropTypes.object,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "account.invites"
  };

  constructor(props) {
    super(props);

    this.initialValues = {
      inviteInterval:
        get(props, "data.inviteInterval") ||
        (props.data.operations || [])
          .find(op => op.name === "update")
          ?.fields?.find(field => field.name === "inviteInterval")?.value ||
        ""
    };
  }

  // -- VALIDATION -- //

  validationSchema = () => {
    const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      inviteInterval: Yup.string().required()
    });
  };

  onlySubmitDirtyValues = values => {
    const dirtyValues = {};
    Object.keys(values).forEach(key => {
      if (values[key] !== this.initialValues[key]) {
        dirtyValues[key] = values[key];
      }
    });
    this.props.onFormikSubmit(dirtyValues);
  };

  getInviteIntervalOptions = () => {
    const { data } = this.props;

    const updateOperation = (data.operations || []).find(
      operation => operation.name === "update"
    );

    if (!updateOperation) {
      return [];
    }

    const inviteIntervalField = (updateOperation.fields || []).find(
      field => field.name === "inviteInterval"
    );

    if (!inviteIntervalField) {
      return [];
    }

    return inviteIntervalField.options.map(option => ({
      key: option.value,
      text: option.text,
      value: option.value,
      disabled: option.disabled
    }));
  };

  // -- RENDER -- //

  render() {
    const { onReset, onSubmit, renderMessage, violationErrors, copyKey, copy } =
      this.props;

    return (
      <Formik
        initialValues={this.initialValues} // required by semantic-ui react
        validateOnMount={true}
        enableReinitialize={true}
        validationSchema={this.validationSchema()}
        onSubmit={this.onlySubmitDirtyValues}
      >
        {formikProps => {
          return (
            <Segment vertical padded textAlign="left">
              <Form className="ui form">
                {renderMessage(formikProps, copyKey)}

                <Header as="h3">{copy(`${copyKey}.title`)}</Header>
                <p>{copy(`${copyKey}.body`)}</p>

                <Field
                  name="inviteInterval"
                  label={copy("account.invites.interval.label")}
                  placeholder={copy("account.invites.interval.placeholder")}
                  apiErrors={violationErrors}
                  component={FormikSemanticDropdown}
                  options={this.getInviteIntervalOptions()}
                />

                <FormikActionsPanel
                  reset={true}
                  onReset={onReset}
                  submit={true}
                  useSubmitModal={true}
                  onSubmit={onSubmit}
                  modalCopy={copy(`account.modals`)}
                />
              </Form>
            </Segment>
          );
        }}
      </Formik>
    );
  }
}

const mapStateToProps = state => ({});

export default connect(mapStateToProps)(MiscellaneousForm);
